import { api } from "./client";

export interface AccountBalance {
  balance: number;
  currency: string;
  alertThreshold?: number;
}

export interface AccountTransaction {
  id: string;
  type: string;
  amount: number;
  description: string;
  timestamp: string;
}

export interface TariffRate {
  network?: string;
  country?: string;
  dataRatePerMb?: number;
  smsRate?: number;
}

export interface TariffInfo {
  id: string;
  name: string;
  rates: TariffRate[];
}

export interface PaymentRecord {
  id: string;
  customerId: string;
  amount: number;
  currency: string;
  status: string;
  stripeSessionId?: string;
  description: string;
  creditAddedToProvider: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TopUpResponse {
  sessionId: string;
  url: string;
}

export interface UsageData {
  [key: string]: unknown;
}

export const billingApi = {
  getBalance: () =>
    api.get<{ data: AccountBalance }>("/billing/balance"),

  getTransactions: () =>
    api.get<{ data: AccountTransaction[] }>("/billing/transactions"),

  getUsage: () =>
    api.get<{ data: UsageData }>("/billing/usage"),

  getEndpointUsage: (endpointId: string) =>
    api.get<{ data: UsageData }>(`/billing/usage/${endpointId}`),

  getTariff: () =>
    api.get<{ data: TariffInfo }>("/billing/tariff"),

  topUp: (amount: number, currency = "GBP") =>
    api.post<{ data: TopUpResponse }>("/billing/topup", {
      amount,
      currency,
      successUrl: `${window.location.origin}/payments?status=success`,
      cancelUrl: `${window.location.origin}/payments?status=cancelled`,
    }),

  getPayments: (limit = 50, offset = 0) =>
    api.get<{ data: PaymentRecord[]; total: number }>(
      `/billing/payments?limit=${limit}&offset=${offset}`,
    ),
};
